import { render, staticRenderFns } from "./index-inner-bv.vue?vue&type=template&id=6d99aacf&"
import script from "./index-inner-bv.vue?vue&type=script&lang=js&"
export * from "./index-inner-bv.vue?vue&type=script&lang=js&"
import style0 from "./index-inner-bv.vue?vue&type=style&index=0&id=6d99aacf&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports